<script>
  import { mapGetters } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import { isPhoneGap } from '@/modules/util/util'
  import kebabcase from 'lodash.kebabcase'
  import imageUrl from '@/css/images/user-icon.svg'
  export default {
    props: {
      header: {
        type: String,
        default: ''
      },
      isBackLink: {
        type: String,
        default: 'Yes'
      },
      isShowSubNavBar: {
        type: [Boolean, String],
        default: false
      },
      SelectedContenttab: {
        type: String,
        default: ''
      },
      isShowRightNavBar: {
        type: [Boolean, String],
        default: true
      },
      isChatModule: {
        type: [Boolean, String],
        default: false
      },
      randomNo: {
        type: [Number, String],
        default: 0
      }
    },
    data() {
      return {
        selectedCategory: ''
      }
    },
    computed: {
      ...mapGetters([
        'MainMenuLayout',
        'ImageGalleries',
        'DesignSettings',
        'SelectedAlbumtab',
        'ActiveAlbumCategory',
        'MainMenu',
        'ChatsUser',
        'SidePanelActive',
        'resource',
        'AppConfig',
        'messageTypers'
      ]),
      showTyping () {
        return (this.messageTypers.name !== '')
      },
      PostCategories() {
        if (this.ImageGalleries.Parent.PostCategories) {
          let Category = JSON.parse(this.ImageGalleries.Parent.PostCategories)
          this.selectedCategory = this.SelectedAlbumtab ? this.selectedCategory || Category[0] : Category[0]
          return Category
        } else {
          let data = [...new Set(this.ImageGalleries.Galleries.map(post => post.Category))] // if category not present in parent then find into the post.
          this.selectedCategory = this.SelectedAlbumtab ? this.selectedCategory || data[0] : data[0]
          return data
        }
      },
      BackLink() {
        // console.log(this.$f7.views.main.history.length )
        // if (this.$f7 && this.$f7.views.main.history.length <=1) {
        //   return 'No'
        // } else {
        return this.isBackLink
        // }
      },
      getNavStyle() {
        if (Helper.IsValid(this.DesignSettings.TitleBarOpacity)) {
          let hashCode = Helper.HashCodeFromInt(this.DesignSettings.AppThemeColor)
          let colorrgb = Helper.hexToRgb(hashCode)
          return {
            'z-index': '7000',
            'color': Helper.HashCodeFromInt(this.DesignSettings.TitleBarFontColor),
            'background': 'rgba(' + colorrgb + ',' + this.DesignSettings.TitleBarOpacity + ')'
          }
        }
      },
      getNavTitleStyle() {
        if (Helper.IsValid(this.DesignSettings.TitleBarFontName)) {
          return {
            'font-family': this.DesignSettings.TitleBarFontName
          }
        }
      },
      UserId() {
        return this.ChatsUser.id
      },
    },
    watch: {
      SelectedAlbumtab: function(val, oldVal) {
        this.selectedCategory = val
        if (!this.$f7) return
        this.$f7.tab.show('#tab-' + this.categoryId(val), true)
      }
    },
    methods: {
      ConvertBoolean(value) {
        return Helper.convertBoolean(value)
      },
      getSubTitleForChat () {
        if (this.showTyping) {
          return this.messageTypers.name
        } else {
          return 'ffffffffff'
        }
      },
      IsNullOrEmpty(value) {
        return Helper.IsNullOrEmpty(value)
      },
      categoryId: function(value) {
        var result = value.replace(/ /g, "-")
        return result + '' + this.randomNo
      },
      categorySelect(category, index) {
        if (this.ActiveAlbumCategory === category) {
          return true
        } else if (this.ActiveAlbumCategory === '' && index === 0) {
          return true
        }
        return false
      },
      addPadding() {
        return isPhoneGap() ? false : true
      },
      getUserImage() {
        if(!this.IsNullOrEmpty(this.ChatsUser.userImage)) {
          return `${this.AppConfig.Urls.ContentAssetsBaseUrl}${this.ChatsUser.userImage}`
        } else {
          return imageUrl
        }
      }
    }
  }
</script>
<template>
  <f7-navbar  sliding :style="getNavStyle" class="header-navbar">
    <f7-nav-left v-if="BackLink == 'Yes'" :back-link="resource.backBtn" sliding :class="{'add-padding' : addPadding()}">
    </f7-nav-left>
    <f7-nav-left v-else>
    </f7-nav-left>
     <f7-nav-title :style="getNavTitleStyle" :title="header" :subtitle="getSubTitleForChat()"
          :class="{'title_m_width' : (MainMenuLayout === 2 && ConvertBoolean(isShowRightNavBar)), 'fixed_subTitleBar' : !showTyping }">
        <!-- <template>
        <div class="title-wrapper" :style="getNavTitleStyle">{{header}}</div>
        </template>
        </template>-->
      </f7-nav-title>
    <!-- <div class="chat-header-title">
      <f7-nav-title :class="{'title_m_width' : (!IsNullOrEmpty(this.UserId) && ConvertBoolean(isChatModule) && MainMenuLayout === 2 && ConvertBoolean(isShowRightNavBar))}">
        <template>
        <div class="title-wrapper" :style="getNavTitleStyle">{{header}}</div>
        </template>-->
      <div v-if="showTyping" class="sub-title-wrapper" :style="getNavTitleStyle">{{messageTypers.name}}</div>
    </div>
    <f7-nav-right v-if="MainMenuLayout === 2 && ConvertBoolean(isShowRightNavBar)">
      <f7-link v-if="!IsNullOrEmpty(this.UserId) && ConvertBoolean(isChatModule)" popup-open="#user-profile-edit-popup" style="height: 100%;">
        <div class="message-avatar" :style="`background-image: url(&quot;${getUserImage()}&quot;);`"></div>
      </f7-link>
      <f7-link v-if="!SidePanelActive" panel-open="right">
        <f7-icon icon="icon-bars"></f7-icon>
      </f7-link>
      <f7-link v-else panel-close>
        <f7-icon icon="icon-bars"></f7-icon>
      </f7-link>
    </f7-nav-right>
    <f7-nav-right v-else>
      <f7-link v-if="!IsNullOrEmpty(this.UserId) && ConvertBoolean(isChatModule)" popup-open="#user-profile-edit-popup" style="height: 100%;">
        <div class="message-avatar" :style="`background-image: url(&quot;${getUserImage()}&quot;);`"></div>
      </f7-link>
    </f7-nav-right>
    <template v-if="PostCategories.length > 1 && PostCategories[0] != ''">
      <f7-subnavbar  sliding v-if="$theme.ios && ConvertBoolean(isShowSubNavBar)" :style="getNavStyle">
        <f7-segmented>
          <f7-button ref="buttontab"
            v-for="(category,index) in PostCategories"
            :tab-link="'#tab-'+categoryId(category)"
            v-if="index < 3" :key="index"
            :tab-link-active="categorySelect(category, index)"
            >
            {{category}}
          </f7-button>
          <f7-button
            v-if="PostCategories.length === 4"
            :tab-link="'#tab-'+categoryId(PostCategories[3])"
            >
            {{PostCategories[3]}}
          </f7-button>
          <f7-button
            v-if="PostCategories.length > 4"
            popover-open="#my-popover"
            >
            More
          </f7-button>
        </f7-segmented>
      </f7-subnavbar>
      <f7-popover id="my-popover" v-if="$theme.ios && ConvertBoolean(isShowSubNavBar) && PostCategories.length > 4">
        <f7-list>
          <f7-list-button
            popover-close
            v-for="(category,index) in PostCategories"
            v-if="index > 2"
            :tab-link="'#tab-'+categoryId(category)"
            :key="index">
            {{category}}
          </f7-list-button>
        </f7-list>
      </f7-popover>
    </template>
  </f7-navbar>
</template>
<style scoped>
  /* .add-padding >>> span {
    padding-top: 4px !important;
  } */
  .menu-icon{
    margin-left: 0 !important;
  }
  .header-navbar >>> div {
    padding: 0 !important;
  }
  .ios .navbar .right >>> .link {
    margin-left: 0px !important;
  }
   .fixed_subTitleBar{
    margin-top: 11px !important;
  }
  .fixed_subTitleBar >>> .subtitle {
    visibility: hidden;
  }
  .title_m_width {
    max-width: 160px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/header/Header.vue